export default "__VITE_ASSET__Qf10cE3S__"